module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('notification', {
      key: notification,
      attrs: {
        "message": notification.message,
        "icon": notification.icon,
        "type": notification.type,
        "vertical-align": notification.verticalAlign,
        "horizontal-align": notification.horizontalAlign
      },
      on: {
        "on-close": function($event) {
          return _vm.removeNotification(index)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f11fb8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/NotificationPlugin/Notifications.vue
// module id = 560
// module chunks = 1